import { render } from "./UserBeltAchievementsComponent.vue?vue&type=template&id=6dc86e76&scoped=true&ts=true"
import script from "./UserBeltAchievementsComponent.vue?vue&type=script&lang=ts"
export * from "./UserBeltAchievementsComponent.vue?vue&type=script&lang=ts"

import "./UserBeltAchievementsComponent.vue?vue&type=style&index=0&id=6dc86e76&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc86e76"]])

export default __exports__